export default "__VITE_ASSET__DEoNwh3P__"